import React, { createContext, useContext, useState, useEffect } from 'react';

const AppDataContext = createContext();

export const useAppData = () => {
    const context = useContext(AppDataContext);
    if (!context) {
        throw new Error('useAppData must be used within an AppDataProvider');
    }
    return context;
};

export const AppDataProvider = ({ children }) => {
    const [appData, setAppData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAppData = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch('/api/app-data');

            if (!response.ok) {
                throw new Error(`Failed to fetch app data: ${response.status}`);
            }

            const result = await response.json();

            if (result.success && result.data) {
                setAppData(result.data);
            } else {
                // Set default empty data if no data exists
                setAppData({
                    iosAppLink: '',
                    androidAppLink: '',
                    whatsappNumber: '',
                    phoneNumber: '',
                    email: '',
                    facebookLink: '',
                    instagramLink: '',
                    twitterLink: '',
                    tiktokLink: ''
                });
            }
        } catch (err) {
            console.error('Error fetching app data:', err);
            setError(err.message);

            // Set default empty data on error
            setAppData({
                iosAppLink: '',
                androidAppLink: '',
                whatsappNumber: '',
                phoneNumber: '',
                email: '',
                facebookLink: '',
                instagramLink: '',
                twitterLink: '',
                tiktokLink: ''
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAppData();
    }, []);

    const value = {
        appData,
        loading,
        error,
        refetch: fetchAppData
    };

    return (
        <AppDataContext.Provider value={value}>
            {children}
        </AppDataContext.Provider>
    );
};
